var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    {
      class:
        _vm.object.type == "string"
          ? _vm.object.sequence == 0
            ? "ma-0 mb-n3 pa-0"
            : "ma-0 my-n3 pa-0"
          : "ma-0 pa-0",
      attrs: { fluid: "" },
    },
    [
      _vm._t(
        _vm.object.name,
        function () {
          return [
            _vm.showLabel
              ? _c(
                  "v-sheet",
                  { staticClass: "d-inline-block text-truncate transparent" },
                  [
                    _c("span", { staticClass: "text--secondary" }, [
                      _vm._v(" " + _vm._s(_vm.$t(_vm.object.label)) + " "),
                    ]),
                  ]
                )
              : _vm._e(),
            (_vm.type == "select" && _vm.datatype == "all_staff") ||
            (_vm.type == "select" && _vm.datatype == "staff")
              ? _c("v-autocomplete", {
                  ref: "selectstaff",
                  attrs: {
                    items: _vm.allDataTrans,
                    placeholder:
                      _vm.datatype == "all_staff" || _vm.datatype == "staff"
                        ? _vm.$t(
                            "label_essweb_leaveBalance_list_staffNameLabel"
                          ) +
                          "/" +
                          _vm.$t("label_essweb_leaveBalance_list_staffIdLabel")
                        : _vm.$t(_vm.object.label),
                    height: "auto",
                    filled: _vm.filled,
                    disabled: _vm.object.disabled,
                    chips: _vm.object.chips
                      ? _vm.object.chips
                      : _vm.object.multiple,
                    "deletable-chips": _vm.object.multiple,
                    "small-chips": _vm.object.multiple,
                    color: "primary ",
                    dense: "",
                    filter: _vm.$staffFilter,
                    "menu-props": {
                      offsetY: true,
                      transition: "slide-y-transition",
                      rounded: true,
                      contentClass: "elevation-4",
                    },
                    "no-data-text": _vm.loading
                      ? _vm.$t("message_essweb_system_tips_loadingLabel")
                      : _vm.$vuetify.noDataText,
                    "search-input": "",
                    multiple: _vm.object.multiple,
                    "hide-details": "",
                    "single-line": "",
                    "item-text": _vm.selectKey,
                    "item-value": _vm.valueKey,
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "no-data",
                        fn: function () {
                          return [_c("noContent")]
                        },
                        proxy: true,
                      },
                      _vm.object.multiple &&
                      _vm.allDataTrans &&
                      _vm.allDataTrans.length > 0
                        ? {
                            key: "prepend-item",
                            fn: function () {
                              return [
                                _vm.object.multiple
                                  ? _c(
                                      "v-list-item",
                                      {
                                        staticClass: "px-4",
                                        on: {
                                          click: function ($event) {
                                            _vm.$nextTick(function () {
                                              if (
                                                _vm.modelValue.length ===
                                                _vm.allDataTrans.length
                                              ) {
                                                _vm.modelValue = []
                                              } else {
                                                _vm.modelValue = []
                                                _vm.allDataTrans.map(function (
                                                  item
                                                ) {
                                                  _vm.modelValue.push(
                                                    item[_vm.valueKey]
                                                  )
                                                })
                                              }
                                            })
                                          },
                                        },
                                      },
                                      [
                                        _c(
                                          "v-list-item-action",
                                          { staticClass: "mx-0 my-0 mr-1" },
                                          [
                                            _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "material-icons-round",
                                                class:
                                                  _vm.modelValue.length !== 0 &&
                                                  _vm.modelValue.length ===
                                                    _vm.allDataTrans.length
                                                    ? "primary--text"
                                                    : _vm.modelValue.length >
                                                        0 &&
                                                      _vm.modelValue.length !==
                                                        _vm.allDataTrans.length
                                                    ? "primary--text"
                                                    : "text--secondary",
                                              },
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      _vm.modelValue.length !==
                                                        0 &&
                                                        _vm.modelValue
                                                          .length ===
                                                          _vm.allDataTrans
                                                            .length
                                                        ? "check_box"
                                                        : _vm.modelValue
                                                            .length > 0 &&
                                                          _vm.modelValue
                                                            .length !==
                                                            _vm.allDataTrans
                                                              .length
                                                        ? "indeterminate_check_box"
                                                        : "check_box_outline_blank"
                                                    ) +
                                                    " "
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                        _c(
                                          "v-list-item-content",
                                          [
                                            _c("v-list-item-title", [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm.$t(
                                                      "label_essweb_system_select_selectAllLabel"
                                                    )
                                                  )
                                              ),
                                            ]),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                _c("v-divider"),
                              ]
                            },
                            proxy: true,
                          }
                        : null,
                      {
                        key: "selection",
                        fn: function (data) {
                          return [
                            _vm._t(
                              "selection",
                              function () {
                                return [
                                  data.index < _vm.$selectSetting.maxChips
                                    ? _c(
                                        "v-chip",
                                        _vm._b(
                                          {
                                            staticClass: "my-1",
                                            attrs: {
                                              close: "",
                                              pill: "",
                                              small: _vm.smallChip,
                                              "input-value": data.selected,
                                            },
                                            on: {
                                              click: data.select,
                                              "click:close": function ($event) {
                                                return _vm.removeChips(
                                                  data.item[_vm.valueKey]
                                                )
                                              },
                                            },
                                          },
                                          "v-chip",
                                          data.attrs,
                                          false
                                        ),
                                        [
                                          _c("StaffAvatar", {
                                            attrs: {
                                              left: "",
                                              small: _vm.smallChip,
                                              contentClass: "white--text",
                                              isTemp: data.item.is_temp,
                                              src: data.item.staff_avatar,
                                              staff_name:
                                                data.item[_vm.showKey],
                                            },
                                          }),
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.$getCommonLangValue(
                                                  data.item[_vm.showKey]
                                                )
                                              ) +
                                              " "
                                          ),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  data.index === _vm.$selectSetting.maxChips
                                    ? _c("v-hover", {
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "default",
                                              fn: function (ref) {
                                                var hover = ref.hover
                                                return [
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass: "py-2",
                                                      class: hover
                                                        ? "rounded primary--text"
                                                        : "text--secondary",
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          $event.stopPropagation()
                                                          return function () {
                                                            _vm.showSelected = true
                                                            if (
                                                              _vm.$refs
                                                                .selectstaff
                                                            ) {
                                                              _vm.$refs.selectstaff.blur()
                                                            }
                                                          }.apply(
                                                            null,
                                                            arguments
                                                          )
                                                        },
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        " ..." +
                                                          _vm._s(
                                                            _vm.object.value
                                                              .length -
                                                              _vm.$selectSetting
                                                                .maxChips
                                                          ) +
                                                          _vm._s(
                                                            _vm.$t(
                                                              "label_essweb_selection_moreItemLabel"
                                                            )
                                                          ) +
                                                          " "
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              },
                                            },
                                          ],
                                          null,
                                          true
                                        ),
                                      })
                                    : _vm._e(),
                                ]
                              },
                              { data: data, object: _vm.object }
                            ),
                          ]
                        },
                      },
                      {
                        key: "item",
                        fn: function (data) {
                          return [
                            _c(
                              "v-list-item",
                              _vm._g(
                                _vm._b(
                                  {
                                    staticClass: "px-4 transparent",
                                    class:
                                      _vm.modelValue.indexOf(
                                        data.item[_vm.valueKey]
                                      ) != -1
                                        ? "primary lighten-5"
                                        : "transparent",
                                  },
                                  "v-list-item",
                                  data.attrs,
                                  false
                                ),
                                data.on
                              ),
                              [
                                _vm.object.multiple
                                  ? _c(
                                      "v-list-item-action",
                                      [
                                        _c("v-checkbox", {
                                          staticClass: "primary--text",
                                          attrs: {
                                            color: "primary",
                                            ripple: false,
                                            value:
                                              _vm.modelValue.indexOf(
                                                data.item[_vm.valueKey]
                                              ) != -1,
                                            "input-value":
                                              _vm.modelValue.indexOf(
                                                data.item[_vm.valueKey]
                                              ) != -1,
                                          },
                                        }),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                _vm.object.avatar
                                  ? _c(
                                      "v-list-item-avatar",
                                      [
                                        _vm._t(
                                          "item.avatar",
                                          function () {
                                            return [
                                              _c("StaffAvatar", {
                                                attrs: {
                                                  size: "36",
                                                  isTemp: data.item.is_temp,
                                                  src: data.item.staff_avatar,
                                                  staff_name:
                                                    data.item[_vm.showKey],
                                                },
                                              }),
                                            ]
                                          },
                                          { data: data, object: _vm.object }
                                        ),
                                      ],
                                      2
                                    )
                                  : _vm._e(),
                                _c(
                                  "v-list-item-content",
                                  [
                                    _c(
                                      "v-list-item-title",
                                      [
                                        _vm._t(
                                          "item.title",
                                          function () {
                                            return [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm.$getCommonLangValue(
                                                      data.item[_vm.showKey]
                                                    )
                                                  ) +
                                                  " "
                                              ),
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "text--secondary text-caption-xs",
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      data.item[_vm.selectKey]
                                                    )
                                                  ),
                                                ]
                                              ),
                                            ]
                                          },
                                          { data: data, object: _vm.object }
                                        ),
                                      ],
                                      2
                                    ),
                                    _vm.object.twoLine
                                      ? _c(
                                          "v-list-item-subtitle",
                                          [
                                            _vm._t(
                                              "item.subtitle",
                                              function () {
                                                return [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        _vm.$getCommonLangValue(
                                                          data.item[_vm.subKey]
                                                            ? data.item[
                                                                _vm.subKey
                                                              ]
                                                            : ""
                                                        )
                                                      ) +
                                                      " "
                                                  ),
                                                ]
                                              },
                                              { data: data, object: _vm.object }
                                            ),
                                          ],
                                          2
                                        )
                                      : _vm._e(),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ]
                        },
                      },
                    ],
                    null,
                    true
                  ),
                  model: {
                    value: _vm.modelValue,
                    callback: function ($$v) {
                      _vm.modelValue = $$v
                    },
                    expression: "modelValue",
                  },
                })
              : _vm._e(),
            _vm.type == "select" &&
            _vm.datatype != "all_staff" &&
            _vm.datatype != "staff" &&
            _vm.datatype != "tree"
              ? _c("v-autocomplete", {
                  ref: "select",
                  attrs: {
                    items: _vm.allDataTrans,
                    placeholder: _vm.$t(_vm.object.label),
                    filled: "",
                    height: "auto",
                    disabled: _vm.object.disabled,
                    chips: _vm.object.multiple,
                    "deletable-chips": _vm.object.multiple,
                    "small-chips": _vm.object.multiple,
                    color: "primary ",
                    dense: "",
                    "menu-props": {
                      offsetY: true,
                      transition: "slide-y-transition",
                      rounded: true,
                      contentClass: "elevation-4",
                    },
                    "no-data-text": _vm.loading
                      ? _vm.$t("message_essweb_system_tips_loadingLabel")
                      : _vm.$vuetify.noDataText,
                    multiple: _vm.object.multiple,
                    "hide-details": "",
                    "single-line": "",
                    "item-text": _vm.selectKey,
                    "item-value": _vm.valueKey,
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "no-data",
                        fn: function () {
                          return [_c("noContent")]
                        },
                        proxy: true,
                      },
                      _vm.object.multiple && _vm.allDataTrans.length > 0
                        ? {
                            key: "prepend-item",
                            fn: function () {
                              return [
                                _vm.object.multiple
                                  ? _c(
                                      "v-list-item",
                                      {
                                        staticClass: "px-4",
                                        on: {
                                          click: function ($event) {
                                            _vm.$nextTick(function () {
                                              if (
                                                _vm.modelValue.length ===
                                                _vm.allDataTrans.length
                                              ) {
                                                _vm.modelValue = []
                                              } else {
                                                _vm.modelValue = []
                                                _vm.allDataTrans.map(function (
                                                  item
                                                ) {
                                                  _vm.modelValue.push(
                                                    item[_vm.valueKey]
                                                  )
                                                })
                                              }
                                            })
                                          },
                                        },
                                      },
                                      [
                                        _c(
                                          "v-list-item-action",
                                          { staticClass: "mx-0 my-0 mr-1" },
                                          [
                                            _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "material-icons-round",
                                                class:
                                                  _vm.modelValue.length !== 0 &&
                                                  _vm.modelValue.length ===
                                                    _vm.allDataTrans.length
                                                    ? "primary--text"
                                                    : _vm.modelValue.length >
                                                        0 &&
                                                      _vm.modelValue.length !==
                                                        _vm.allDataTrans.length
                                                    ? "primary--text"
                                                    : "text--secondary",
                                              },
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      _vm.modelValue.length !==
                                                        0 &&
                                                        _vm.modelValue
                                                          .length ===
                                                          _vm.allDataTrans
                                                            .length
                                                        ? "check_box"
                                                        : _vm.modelValue
                                                            .length > 0 &&
                                                          _vm.modelValue
                                                            .length !==
                                                            _vm.allDataTrans
                                                              .length
                                                        ? "indeterminate_check_box"
                                                        : "check_box_outline_blank"
                                                    ) +
                                                    " "
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                        _c(
                                          "v-list-item-content",
                                          [
                                            _c("v-list-item-title", [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm.$t(
                                                      "label_essweb_system_select_selectAllLabel"
                                                    )
                                                  )
                                              ),
                                            ]),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                _c("v-divider"),
                              ]
                            },
                            proxy: true,
                          }
                        : null,
                      {
                        key: "selection",
                        fn: function (data) {
                          return [
                            _vm._t(
                              "selection",
                              function () {
                                return [
                                  _vm.object.statusChip &&
                                  data.index < _vm.$selectSetting.maxChips
                                    ? _c("StatusChip", {
                                        attrs: {
                                          slideColor: data.item.f1
                                            ? data.item.f1
                                            : "grey",
                                          bgColor: data.item.f2
                                            ? data.item.f2
                                            : "rgba(155, 153, 153, 0.3)",
                                          icon: _vm.object.statusChip == "icon",
                                          close: "",
                                        },
                                        on: {
                                          close: function ($event) {
                                            return _vm.removeChips(
                                              data.item[_vm.valueKey]
                                            )
                                          },
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "status",
                                              fn: function () {
                                                return [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        _vm.$getCommonLangValue(
                                                          data.item[_vm.showKey]
                                                        )
                                                      ) +
                                                      " "
                                                  ),
                                                ]
                                              },
                                              proxy: true,
                                            },
                                          ],
                                          null,
                                          true
                                        ),
                                      })
                                    : _vm._e(),
                                  !_vm.object.statusChip &&
                                  data.index < _vm.$selectSetting.maxChips
                                    ? _c(
                                        "v-chip",
                                        _vm._b(
                                          {
                                            staticClass: "my-1",
                                            class: data.item.f1
                                              ? "white--text"
                                              : "",
                                            attrs: {
                                              close: "",
                                              color: data.item.f1
                                                ? data.item.f1
                                                : undefined,
                                              small: _vm.smallChip,
                                              "input-value": data.selected,
                                            },
                                            on: {
                                              click: data.select,
                                              "click:close": function ($event) {
                                                return _vm.removeChips(
                                                  data.item[_vm.valueKey]
                                                )
                                              },
                                            },
                                          },
                                          "v-chip",
                                          data.attrs,
                                          false
                                        ),
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.$getCommonLangValue(
                                                  data.item[_vm.showKey]
                                                )
                                              ) +
                                              " "
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                  data.index === _vm.$selectSetting.maxChips
                                    ? _c("v-hover", {
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "default",
                                              fn: function (ref) {
                                                var hover = ref.hover
                                                return [
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass: "py-2",
                                                      class: hover
                                                        ? "rounded primary--text"
                                                        : "text--secondary",
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          $event.stopPropagation()
                                                          return function () {
                                                            _vm.showSelected = true
                                                            if (
                                                              _vm.$refs
                                                                .selectstaff
                                                            ) {
                                                              _vm.$refs.selectstaff.blur()
                                                            }
                                                          }.apply(
                                                            null,
                                                            arguments
                                                          )
                                                        },
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        " ..." +
                                                          _vm._s(
                                                            _vm.object.value
                                                              .length -
                                                              _vm.$selectSetting
                                                                .maxChips
                                                          ) +
                                                          _vm._s(
                                                            _vm.$t(
                                                              "label_essweb_selection_moreItemLabel"
                                                            )
                                                          ) +
                                                          " "
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              },
                                            },
                                          ],
                                          null,
                                          true
                                        ),
                                      })
                                    : _vm._e(),
                                ]
                              },
                              { data: data, object: _vm.object }
                            ),
                          ]
                        },
                      },
                      {
                        key: "item",
                        fn: function (data) {
                          return [
                            _c(
                              "v-list-item",
                              _vm._g(
                                _vm._b(
                                  {
                                    staticClass: "px-4 transparent",
                                    class:
                                      _vm.modelValue.indexOf(
                                        data.item[_vm.valueKey]
                                      ) != -1
                                        ? "primary lighten-5"
                                        : "transparent",
                                  },
                                  "v-list-item",
                                  data.attrs,
                                  false
                                ),
                                data.on
                              ),
                              [
                                _vm.object.multiple
                                  ? _c(
                                      "v-list-item-action",
                                      [
                                        _c("v-checkbox", {
                                          staticClass: "primary--text",
                                          attrs: {
                                            color: "primary",
                                            ripple: false,
                                            "input-value":
                                              _vm.modelValue.indexOf(
                                                data.item[_vm.valueKey]
                                              ) != -1,
                                            value:
                                              _vm.modelValue.indexOf(
                                                data.item[_vm.valueKey]
                                              ) != -1,
                                          },
                                        }),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                _c(
                                  "v-list-item-content",
                                  [
                                    _c(
                                      "v-list-item-title",
                                      [
                                        _vm._t(
                                          "item.title",
                                          function () {
                                            return [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm.$getCommonLangValue(
                                                      data.item[_vm.showKey]
                                                    )
                                                  ) +
                                                  " "
                                              ),
                                            ]
                                          },
                                          { data: data, object: _vm.object }
                                        ),
                                      ],
                                      2
                                    ),
                                    _vm.object.twoLine
                                      ? _c(
                                          "v-list-item-subtitle",
                                          [
                                            _vm._t(
                                              "item.subtitle",
                                              function () {
                                                return [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        _vm.$getCommonLangValue(
                                                          data.item[_vm.subKey]
                                                        )
                                                      ) +
                                                      " "
                                                  ),
                                                ]
                                              },
                                              { data: data, object: _vm.object }
                                            ),
                                          ],
                                          2
                                        )
                                      : _vm._e(),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ]
                        },
                      },
                    ],
                    null,
                    true
                  ),
                  model: {
                    value: _vm.modelValue,
                    callback: function ($$v) {
                      _vm.modelValue = $$v
                    },
                    expression: "modelValue",
                  },
                })
              : _vm._e(),
            _vm.type == "string"
              ? _c("v-text-field", {
                  attrs: {
                    filled: _vm.filled,
                    dense: "",
                    rules: _vm.$GetRules(
                      ["_SpecialCharacters_Rules"],
                      [_vm.$t(_vm.object.label)]
                    ),
                    placeholder: _vm.$t(_vm.object.label),
                    "single-line": "",
                  },
                  model: {
                    value: _vm.modelValue,
                    callback: function ($$v) {
                      _vm.modelValue = $$v
                    },
                    expression: "modelValue",
                  },
                })
              : _vm.type == "daterange"
              ? _c("DateTimePicker", {
                  attrs: {
                    isRequire: "",
                    hideDetail: "",
                    type: _vm.type,
                    value: _vm.object.value,
                    defaultTime: _vm.object.value,
                    max: _vm.object.max,
                    min: _vm.object.min,
                    defaultStartTime: _vm.defaultStartDate,
                    defaultEndTime: _vm.defaultEndDate,
                    placeholder: _vm.$t(
                      "label_essweb_RosterRecord_list_seTimeLabel"
                    ),
                  },
                  on: {
                    change: function (time, isre) {
                      _vm.dateTerminal = time
                      _vm.object.value = time
                      if (isre) {
                        _vm.defaultStartDate = time ? time.split(" - ")[0] : ""
                        _vm.defaultEndDate = time ? time.split(" - ")[1] : ""
                      }
                    },
                  },
                })
              : _vm.type == "month"
              ? _c("DateTimePicker", {
                  attrs: {
                    isRequire: "",
                    hideDetail: "",
                    type: _vm.type,
                    value: _vm.object.value,
                    defaultTime: _vm.object.value,
                    max: _vm.object.max,
                    min: _vm.object.min,
                    defaultStartTime: _vm.defaultStartDate,
                    defaultEndTime: _vm.defaultEndDate,
                    placeholder: _vm.$t(_vm.object.label),
                  },
                  on: {
                    change: function (time, isre) {
                      _vm.dateTerminal = time
                      _vm.object.value = time
                    },
                  },
                })
              : _vm._e(),
            _vm.type == "select" && _vm.datatype == "tree"
              ? _c("SelectDepartments", {
                  attrs: {
                    items: _vm.allDataTrans,
                    placeholder: _vm.$t(_vm.object.label),
                    multiple: _vm.object.multiple,
                    disabled: _vm.object.disabled,
                    "show-label": false,
                  },
                  on: {
                    "view-select": function ($event) {
                      _vm.showSelected = true
                    },
                  },
                  model: {
                    value: _vm.object.value,
                    callback: function ($$v) {
                      _vm.$set(_vm.object, "value", $$v)
                    },
                    expression: "object.value",
                  },
                })
              : _vm._e(),
          ]
        },
        { object: _vm.object, index: _vm.index }
      ),
      _c("SelectValue", {
        attrs: {
          show: _vm.showSelected,
          "model-key": _vm.valueKey,
          object: _vm.object,
        },
        on: {
          close: function ($event) {
            _vm.showSelected = false
          },
          select: function (e, item) {
            _vm.removeChips(e, item)
          },
        },
        model: {
          value: _vm.modelValue,
          callback: function ($$v) {
            _vm.modelValue = $$v
          },
          expression: "modelValue",
        },
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }